import React from 'react';
import { Views, Neo } from '@singularsystems/neo-react';
import InviteUsersVM from './InviteUsersVM';
import { observer } from 'mobx-react';
import CollapsibleCard from '../../../App/Components/CollapsibleCard';

@observer
export default class InviteUsersView extends Views.ViewBase<InviteUsersVM> {

    constructor(props: unknown) {
        super("Invite Users", InviteUsersVM, props);
    }

    public render() {
        return (
            <div>

                <CollapsibleCard title={"New User"} isExpanded={true}>
                    {this.viewModel.inviteUser &&
                        <Neo.Form onSubmit={() => this.viewModel.submitUserInvite()}>
                            <div className="row">
                                <div className="col-xl-4">
                                    <Neo.FormGroup label={"Enter Email Address"} bind={this.viewModel.inviteUser.meta.inviteEmailAddress} />
                                </div>
                                <div className="col-xl-8 p-0 text-right">
                                    <Neo.Button
                                        isSubmit
                                        size="sm" className="customMarginTop38 mr-3 "
                                        hidden={this.viewModel.inviteUser.inviteEmailAddress === "" ||
                                            !this.viewModel.inviteUser.inviteEmailAddress.includes("@", undefined) ||
                                            !this.viewModel.inviteUser.inviteEmailAddress.includes(".", undefined)}
                                    >{"Invite User"}</Neo.Button>
                                </div>
                            </div>
                        </Neo.Form>
                    }
                </CollapsibleCard>
            </div>
        );
    }
}